import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Input, Spin, message, Card, Result } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import axios from 'axios'

const API = 'https://blog.bjk-med.com/api'

export default function SetPwdPage() {
  const { signerId } = useParams()
  const [loading, setLoading] = useState(true)
  const [info, setInfo] = useState(null)
  const [oldPassword, setOldPassword] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [result, setResult] = useState(null)

  useEffect(() => { if (signerId) fetchInfo() }, [signerId])

  const fetchInfo = async () => {
    try {
      const { data } = await axios.get(`${API}/mini/signer/${signerId}/info`)
      if (data.success) {
        setInfo(data.data)
      } else {
        setResult({ success: false, message: data.message })
      }
    } catch {
      setResult({ success: false, message: '网络错误，请重试' })
    } finally { setLoading(false) }
  }

  const hasPwd = !!info?.has_pwd

  const handleSubmit = async () => {
    if (hasPwd && !oldPassword) return message.warning('请输入原签收密码')
    if (!password) return message.warning('请输入新签收密码')
    if (password !== confirm) return message.warning('两次输入的密码不一致')
    if (password.length < 6) return message.warning('密码至少6位')
    setSubmitting(true)
    try {
      const payload = { password, confirm_password: confirm }
      if (hasPwd) payload.old_password = oldPassword
      const { data } = await axios.post(`${API}/mini/signer/${signerId}/set-password`, payload)
      if (data.success) {
        setResult({ success: true, message: data.message })
      } else {
        message.error(data.message || '提交失败')
      }
    } catch {
      message.error('提交失败，请重试')
    } finally { setSubmitting(false) }
  }

  const handleClose = () => {
    if (typeof WeixinJSBridge !== 'undefined') {
      WeixinJSBridge.call('closeWindow')
    } else {
      window.close()
    }
  }

  if (loading) return <div style={{ textAlign: 'center', paddingTop: '40vh' }}><Spin size="large" tip="加载中..." /></div>

  if (result && !result.success) return (
    <Result status="error" title="无法提交" subTitle={result.message}
      extra={<Button type="primary" onClick={handleClose}>关闭</Button>} />
  )

  if (result && result.success) return (
    <Result status="success" title={hasPwd ? '签收密码修改成功' : '签收密码设置成功'}
      subTitle={`签收人：${info?.signer_name || ''}`}
      extra={<Button type="primary" onClick={handleClose}>关闭</Button>} />
  )

  return (
    <div style={{ maxWidth: 420, margin: '0 auto', padding: 16, paddingBottom: 40 }}>
      <Card title={hasPwd ? '修改签收密码' : '设置签收密码'} style={{ textAlign: 'center' }}>
        <LockOutlined style={{ fontSize: 40, color: '#1677ff', marginBottom: 16 }} />

        {info && (
          <div style={{ fontSize: 14, color: '#666', lineHeight: 2, marginBottom: 16 }}>
            <div><b>签收人：</b>{info.signer_name}</div>
            <div><b>手机尾号：</b>{info.phone_last4 || '-'}</div>
            {hasPwd
              ? <div style={{ color: '#fa8c16' }}>该签收人已设置密码，请输入原密码后设置新密码</div>
              : <div style={{ color: '#52c41a' }}>该签收人尚未设置密码，请直接设置签收密码</div>}
          </div>
        )}

        {hasPwd && (
          <div style={{ marginBottom: 16 }}>
            <Input.Password placeholder="请输入原签收密码" value={oldPassword}
              onChange={e => setOldPassword(e.target.value)} maxLength={20}
              style={{ width: '80%' }} autoComplete="current-password" />
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <Input.Password placeholder="请设置新签收密码（至少6位）" value={password}
            onChange={e => setPassword(e.target.value)} maxLength={20}
            style={{ width: '80%' }} autoComplete="new-password" />
        </div>

        <div style={{ marginBottom: 16 }}>
          <Input.Password placeholder="请再次输入新密码" value={confirm}
            onChange={e => setConfirm(e.target.value)} maxLength={20}
            style={{ width: '80%' }} autoComplete="new-password" />
        </div>

        <Button type="primary" size="large" block loading={submitting}
          disabled={!password || !confirm || (hasPwd && !oldPassword)} onClick={handleSubmit}>
          {hasPwd ? '确认修改' : '确认设置'}
        </Button>
      </Card>
    </div>
  )
}
